import type { ConceptKind } from '../../concepts/kinds';
import { defineReactGame } from '../sdk/react';
import type { GameModule } from '../sdk/toolkit';
import LabelParts from './LabelParts';
import FindPart, { FindInScene } from './FindPart';
import PlaceIt from './PlaceIt';
import SortBins from './SortBins';
import YesNo from './YesNo';
import OddOneOut from './OddOneOut';
import FindAll from './FindAll';
import MemoryPairs from './MemoryPairs';
import SlotOrder from './SlotOrder';
import PictureSentence from './PictureSentence';
import BlockCopy from './BlockCopy';
import TaskChain from './TaskChain';
import WaitForGo from './WaitForGo';
import RotateFind from './RotateFind';
import TraceIt from '../../addons/traceIt/game';
import TileMatch from './TileMatch';
import SupervisorScored from './SupervisorScored';
import SequenceTap from './SequenceTap';
import TimerHold from './TimerHold';

export const MODULES: Record<Exclude<ConceptKind, 'studio'>, GameModule> = {
  tileMatch: defineReactGame(TileMatch),
  supervisorScored: defineReactGame(SupervisorScored),
  sequenceTap: defineReactGame(SequenceTap),
  timerHold: defineReactGame(TimerHold),
  labelParts: defineReactGame(LabelParts),
  findPart: defineReactGame(FindPart),
  findInScene: defineReactGame(FindInScene),
  placeIt: defineReactGame(PlaceIt),
  sortBins: defineReactGame(SortBins),
  yesNo: defineReactGame(YesNo),
  oddOneOut: defineReactGame(OddOneOut),
  findAll: defineReactGame(FindAll),
  memoryPairs: defineReactGame(MemoryPairs),
  slotOrder: defineReactGame(SlotOrder),
  pictureSentence: defineReactGame(PictureSentence),
  blockCopy: defineReactGame(BlockCopy),
  taskChain: defineReactGame(TaskChain),
  waitForGo: defineReactGame(WaitForGo),
  rotateFind: defineReactGame(RotateFind),
  traceIt: defineReactGame(TraceIt),
};
